import { SERVICE_ROUTES } from '../../../config/api-routes';
import instance from '../../../config/instance';

/**
 * Get all shop services/service subcategories
 * This API fetches the complete list of services and subcategories with filtering support
 * @param {object} params - Query parameters for filtering/pagination
 * @param {string} params.search - Search term for service names
 * @param {number} params.page - Page number for pagination
 * @param {number} params.limit - Number of items per page
 * @param {string} params.sortBy - Field to sort by
 * @param {string} params.sortType - Sort order (ASC/DESC)
 * @returns {Promise} - Services data with pagination info
 */
export const getShopServicesApi = async (params = {}) => {
    const queryParams = new URLSearchParams();

    // Add parameters to query string
    Object.keys(params).forEach((key) => {
        if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
            queryParams.append(key, params[key]);
        }
    });

    const queryString = queryParams.toString();
    const url = queryString ? `${SERVICE_ROUTES.GET_SHOP_SERVICES}?${queryString}` : SERVICE_ROUTES.GET_SHOP_SERVICES;

    const response = await instance.get(url);
    return response.data;
};

/**
 * Create new service subcategory
 * This API creates a new service subcategory with the provided details
 * @param {object} payload - Service subcategory data
 * @param {string} payload.name - Service subcategory name
 * @param {string} payload.description - Service description
 * @param {number} payload.price - Service price
 * @param {number} payload.categoryId - Parent category ID
 * @returns {Promise} - Created service subcategory data
 */
export const createServiceSubcategoryApi = async (payload) => {
    const response = await instance.post(SERVICE_ROUTES.CREATE_SERVICE_SUBCATEGORY, payload);
    return response.data;
};
